import { useRepositories } from './useRepositories';

/** The signed-in person's id, or null when signed out. */
export function useMyId(): string | null {
  return useRepositories().session.current().user?.id ?? null;
}
